import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../constants/app-constants';
import { AuthService } from './auth.service';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class PublicGuardService  {
    constructor(public auth: AuthService, public router: Router, public userCacheService: UserCacheService) { }
    canActivate(): boolean {
        if (this.auth.isAuthenticated()) {
            const participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
            const storyId = this.userCacheService.getUserData(AppConstants.STORY_ID);
            if(participantId){
                this.router.navigate([participantId + '/login']);
            }else if(storyId){
                this.router.navigate(['school/'+ storyId + '/login']);
            }
            return false;
        }
        return true;
    }
}